
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./VacuumDearator.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import DOTTrendGraph from "../components/DOTTrendGraph";

import { trackPageVisit } from "../competency/PageTracker";
 

 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function VacuumDearator() {

        useEffect(() => {
  
    trackPageVisit("VacuumDearator");
  
  }, []);

  const { pumpData } = useContext(PumpContext);

  const {  valves, toggleValve, transmitters} = useContext(WellContext);

  const [showDOTTrend, setShowDOTTrend] = useState(false);


  


  const DEFAULT_VALVES = {
  FCV_2951: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2952: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2953: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2954: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("VacuumDearator_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2951: { ...DEFAULT_VALVES.FCV_2951, ...parsed.FCV_2951 },
      FCV_2952: { ...DEFAULT_VALVES.FCV_2952, ...parsed.FCV_2952 },
      FCV_2953: { ...DEFAULT_VALVES.FCV_2953, ...parsed.FCV_2953 },
      FCV_2954: { ...DEFAULT_VALVES.FCV_2954, ...parsed.FCV_2954 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("VacuumDearator_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  
  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};












  // ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES =================

  const [FIC_2944, setFIC_2944] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2944")) || 0;
            setFIC_2944(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2947, setFIC_2947] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2947")) || 0;
            setFIC_2947(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2948, setFIC_2948] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2948")) || 0;
            setFIC_2948(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2945, setPT_2945] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2945")) || 0;
            setPT_2945(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [DOT_2941, setDOT_2941] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("DOT_2941")) || 0;
            setDOT_2941(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2942, setTT_2942] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2942")) || 0;
            setTT_2942(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const FIC_2951 = FIC_2944 + FIC_2947 +FIC_2948;
  const PT_2951 = PT_2945;
  const DOT_2951 = DOT_2941 * 0.89;

  // ================= PUMP and VALVES STATUS =================
const isP2951AOn = pumpData?.["P-2951A"]?.running ?? false;
const isP2951BOn = pumpData?.["P-2951B"]?.running ?? false;

const isP2952AOn = pumpData?.["P-2952A"]?.running ?? false;
const isP2952BOn = pumpData?.["P-2952B"]?.running ?? false;

  const isXV2953Open = valves?.XV_2953 === false;
  const isXV2952Open = valves?.XV_2952 === false;
  const isXV2951Open = valves?.XV_2951 === false;

  const FIC_2952 = isXV2953Open ?2.54 : 0;
  const PT_2954 = isXV2953Open ? 0.234 : 0.03;



  // ================= PUMP STATUS + VALVES =================
const isP2953AOn = pumpData?.["P-2953A"]?.running ?? false;
const isP2953BOn = pumpData?.["P-2953B"]?.running ?? false;

const runningPumps2953 = [isP2953AOn, isP2953BOn].filter(Boolean).length;

// ================= VALVE =================
const valveOpening2954 = Math.max(
  0,
  Math.min(100, Number(valveData?.FCV_2954?.opening || 0))
);

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2957 = 1.3;
const MIN_DISCH_PRESSURE_2957 = 0.03;

// ================= TARGET =================
let targetPT_2957 = MIN_DISCH_PRESSURE_2957;

if (runningPumps2953 > 0) {

  // valve-controlled discharge pressure
  targetPT_2957 =
    MIN_DISCH_PRESSURE_2957 +
    (MAX_DISCH_PRESSURE_2957 - MIN_DISCH_PRESSURE_2957) *
    (valveOpening2954 / 100);

}

// ================= STATE =================
const [PT_2957, setPT_2957] = useState(() => {
  return Number(localStorage.getItem("PT_2957")) || 0.03;
});

// ================= SMOOTHING =================
useEffect(() => {

  const interval = setInterval(() => {

    setPT_2957(prev => {
      const next = prev + (targetPT_2957 - prev) * 0.2; // fast response
      return Number(next.toFixed(3));
    });

  }, 100); // 🔥 fast DCS feel

  return () => clearInterval(interval);

}, [targetPT_2957]);

useEffect(() => {
  localStorage.setItem("PT_2957", PT_2957);
}, [PT_2957]);





  const TT_2953 = TT_2942 * 0.73 - (PT_2957*0.56);
  const PT_2955 = PT_2951 * 0.78 - (PT_2957*0.56);

  const TT_2952 = TT_2953 * 0.89 - (PT_2957*0.26);
  const PT_2953 = PT_2955 * 0.78 - (PT_2957*0.26);

  const TT_2951 = TT_2952 * 0.89 - (PT_2957*0.032);
  const PT_2952 = PT_2953 * 0.78 - (PT_2957*0.032);

  const PT_2956 = PT_2952 * 0.994;

const valveOpening = Number(valveData?.FCV_2951?.opening || 0);

const anyPumpRunning =
  isP2951AOn || isP2951BOn || isP2952AOn || isP2952BOn;

let FIC_2957 = 0;

if (isXV2951Open) {

  if (anyPumpRunning) {
    // 🔥 BOOSTED FLOW
    FIC_2957 = 300 * (valveOpening / 100);
  } else {
    // 🔹 NATURAL FLOW (NO PUMP)
    FIC_2957 = 4 * (valveOpening / 100);
  }

} else {
  FIC_2957 = 0;
}  
  
  const FIC_2957a = isXV2952Open ? 10  : 0;
  const FIC_2957b = 10 * (valveData?.FCV_2952?.opening || 0)/100;

  const FIC_2958 = FIC_2957 + FIC_2957b;
  const FIC_2959 = FIC_2958 * 0.987;
  const PT_29511 = isXV2951Open ? PT_2955 * 1.2* (valveData?.FCV_2951?.opening || 0)/100 : 0.03;




  // ================= BOOSTER INJECTION PUMPS =================
const runningPumps2951 = [isP2951AOn, isP2951BOn].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow2959 = Number(FIC_2959 || 0);
const suctionPressure29511 = Number(PT_29511 || 0);

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_29510 = PT_29511 * 3.5;
const MIN_DISCH_PRESSURE_29510 = 0.03;

// ================= TARGET CALCULATIONS =================
let targetPT_29510 = MIN_DISCH_PRESSURE_29510;
let targetFIC_2956 = 0;

if (runningPumps2951 > 0) {

  // 🔹 Flow boost
  targetFIC_2956 = suctionFlow2959 * 1.034;

  // 🔹 Pressure rises to design max
  targetPT_29510 = MAX_DISCH_PRESSURE_29510;

}

// ================= STATES =================
const [PT_29510, setPT_29510] = useState(() => {
  return Number(localStorage.getItem("PT_29510")) || 0.03;
});

const [FIC_2956, setFIC_2956] = useState(() => {
  return Number(localStorage.getItem("FIC_2956")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_29510(prev => {
      const next = prev + (targetPT_29510 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2956(prev => {
      const next = prev + (targetFIC_2956 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_29510, targetFIC_2956]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_29510", PT_29510);
}, [PT_29510]);

useEffect(() => {
  localStorage.setItem("FIC_2956", FIC_2956);
}, [FIC_2956]);

// ================= LOAD SHARING (OPTIONAL DISPLAY) =================
const loadShare2951 =
  runningPumps2951 > 0 ? (100 / runningPumps2951).toFixed(0) : 0;

// Example (if you want to display per pump later):
const pumpAFlow =
  isP2951AOn && runningPumps2951 > 0
    ? FIC_2956 / runningPumps2951
    : 0;

const pumpBFlow =
  isP2951BOn && runningPumps2951 > 0
    ? FIC_2956 / runningPumps2951
    : 0;

  
    const FIC_2955 = isP2951AOn || isP2951BOn ? FIC_2956 : FIC_2959;
    const PT_2958 = isP2951AOn || isP2951BOn ? PT_29510 : PT_29511;

    

    // =================MAIN INJECTION PUMP STATUS =================
const runningPumps2952 = [isP2952AOn, isP2952BOn].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow2955 = Number(FIC_2955 || 0);
const suctionPressure2958 = Number(PT_2958 || 0);

// ================= DESIGN LIMITS =================
const MIN_DISCH_PRESSURE_2959 = 0.03;
const MAX_MULTIPLIER = 1.5; // pressure amplification factor

// ================= TARGET CALCULATIONS =================
let targetPT_2959 = MIN_DISCH_PRESSURE_2959;
let targetFIC_2954 = 0;

if (runningPumps2952 > 0) {

  // 🔹 Flow boost
  targetFIC_2954 = suctionFlow2955 * 1.534 * ((valveData?.FCV_2953?.opening || 0)/100);

  // 🔹 Pressure amplification (based on suction pressure)
  targetPT_2959 = isP2951AOn || isP2951BOn ? suctionPressure2958 * 300 * MAX_MULTIPLIER * ((valveData?.FCV_2953?.opening || 0)/100) : suctionPressure2958 * 100 * ((valveData?.FCV_2953?.opening || 0)/100);

}

// ================= STATES =================
const [PT_2959, setPT_2959] = useState(() => {
  return Number(localStorage.getItem("PT_2959")) || 0.03;
});

const [FIC_2954, setFIC_2954] = useState(() => {
  return Number(localStorage.getItem("FIC_2954")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2959(prev => {
      const next = prev + (targetPT_2959 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2954(prev => {
      const next = prev + (targetFIC_2954 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100);

  return () => clearInterval(interval);

}, [targetPT_2959, targetFIC_2954]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2959", PT_2959);
}, [PT_2959]);

useEffect(() => {
  localStorage.setItem("FIC_2954", FIC_2954);
}, [FIC_2954]);

// ================= LOAD SHARING =================
const loadShare2952 =
  runningPumps2952 > 0 ? (100 / runningPumps2952).toFixed(0) : 0;

// Optional per-pump contribution
const pumpAFlow2952 =
  isP2952AOn && runningPumps2952 > 0
    ? FIC_2954 / runningPumps2952
    : 0;

const pumpBFlow2952 =
  isP2952BOn && runningPumps2952 > 0
    ? FIC_2954 / runningPumps2952
    : 0;



    const DOT_2952 = isP2953AOn || isP2953BOn ? (DOT_2951/150) * (1 - ((valveData?.FCV_2954?.opening || 0)/100)) : DOT_2951;
    const DOT_2952a = DOT_2952*1000;



    useEffect(() => {
  localStorage.setItem("TT_2953", TT_2953);
}, [TT_2953]);


  return (
    <div className="VacuumDearator-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "253px",
        color: "white",
        background: "rgb(26, 1, 255)", 
        padding: "2px 317px"
      }}>
        VACUUM DEARATOR
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2951 */}
      <Valve
        className="XV-2951"
        tag="XV_2951"
        x={487}
        y={555}
        isClosed={valves.XV_2951}
        toggle={toggleValve}
        r={270}
      />
      {/* XV-2952 */}
      <Valve
        className="XV-2952"
        tag="XV_2952"
        x={592}
        y={371}
        isClosed={valves.XV_2952}
        toggle={toggleValve}
      />
      {/* XV-2953 */}
      <Valve
        className="XV-2953"
        tag="XV_2953"
        x={302}
        y={331}
        isClosed={valves.XV_2953}
        toggle={toggleValve}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2951 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2951"
          style={{ position: "absolute", left: 669, top: 593}}  onClick={() => openPanel("FCV_2951")}>
          
          <defs>
            <linearGradient id="metal_2951">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2951)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2951)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-2952 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2952"
          style={{ position: "absolute", left: 616, top: 486 }}  onClick={() => openPanel("FCV_2952")}>
          
          <defs>
            <linearGradient id="metal_2952">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2952)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2952)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

        {/* FCV-2953 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2953"
          style={{ position: "absolute", left: 1193, top: 248 }}  onClick={() => openPanel("FCV_2953")}>
          
          <defs>
            <linearGradient id="metal_2953">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2953)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2953)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

        {/* FCV-2954 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2954"
          style={{ position: "absolute", left: 1145, top: 83 }}  onClick={() => openPanel("FCV_2954")}>
          
          <defs>
            <linearGradient id="metal_2954">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2954)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2954)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}




<button
  className="dot-trend-btn"
  style={{ left: 520, top: 596 }} // 👈 control position here
  onClick={() => setShowDOTTrend(true)}
>
  📈
</button>

{showDOTTrend && (
  <DOTTrendGraph
    title="NK TECH DOT MULTIVARIABLE TREND"
    tags={[
      { key: "DOT_2951", label: "DOT_2951", color: "#00ff66" },
      { key: "DOT_2952", label: "DOT_2952", color: "#00bfff" },
      { key: "DOT_2952a", label: "DOT_2952a", color: "#ff9800" },
      { key: "valveOpening", label: "Valve", color: "#ff4040" }
    ]}
    values={{
      DOT_2951,
      DOT_2952,
      DOT_2952a,
      valveOpening: valveData?.FCV_2954?.opening || 0
    }}
    onClose={() => setShowDOTTrend(false)}
  />
)}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2951?.opening || 0)}
        x={686}
        y={638}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2952?.opening || 0)}
        x={642}
        y={537}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2953?.opening || 0)}
        x={1220}
        y={287}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2954?.opening || 0)}
        x={1172}
        y={120}
      />



        {/* ================= TRANSMITTERS OUTPUTS ================= */}
      
        <Transmitter
          tag="FIC-2951"
          value={[FIC_2951]}
          x={155}
          y={178}
          unit="LPM"
          max={300}
          HH={289}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER WITH BIOCIDE AND CORROSION INHIBITION TO VACUUM DEARATOR FLASH ZONE"
        />

         <Transmitter
          tag="PT-2951"
          value={PT_2951}
          x={225}
          y={178}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER WITH BIOCIDE AND CORROSION INHIBITION TO VACUUM DEARATOR FLASH ZONE"
        />

        <Transmitter
          tag="FIC-2952"
          value={[FIC_2952]}
          x={153}
          y={326}
          unit="LPM"
          max={10}
          HH={9}
          H={8}
          L={1}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF FLUID FROM OXYGEN SCAVENGER IN GAS SWEETENING UNIT"
        />

         <Transmitter
          tag="PT-2954"
          value={PT_2954}
          x={225}
          y={326}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF FLUID FROM OXYGEN SCAVENGER IN GAS SWEETENING UNIT"
        />
         <Transmitter
          tag="PT-2955"
          value={PT_2955}
          x={390}
          y={424}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT THE BOTTOM REGION OF VACUUM DEARATOR"
        />

        <Transmitter
          tag="TT-2953"
          value={TT_2953}
          x={388}
          y={383}
          unit="°C"
          max={50}
          HH={45}
          H={40}
          L={20}
          LL={5}
          c="lime"
          description="TEMPERATURE OF SEAWATER AT THE BOTTOM REGION OF VACUUM DEARATOR"
        />
         <Transmitter
          tag="PT-2953"
          value={PT_2953}
          x={408}
          y={271}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT THE FLASH ZONE OF VACUUM DEARATOR"
        />

        <Transmitter
          tag="TT-2952"
          value={TT_2952}
          x={408}
          y={237}
          unit="°C"
          max={50}
          HH={45}
          H={40}
          L={20}
          LL={5}
          c="lime"
          description="TEMPERATURE OF SEAWATER AT THE FLASH ZONE OF VACUUM DEARATOR"
        />
         <Transmitter
          tag="PT-2952"
          value={PT_2952}
          x={408}
          y={166}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT THE OVERHEAD ZONE OF VACUUM DEARATOR"
        />

        <Transmitter
          tag="TT-2951"
          value={TT_2951}
          x={408}
          y={129}
          unit="°C"
          max={50}
          HH={45}
          H={40}
          L={20}
          LL={5}
          c="lime"
          description="TEMPERATURE OF SEAWATER AT THE OVERHEAD ZONE OF VACUUM DEARATOR"
        />

        <Transmitter
          tag="PT-2956"
          value={PT_2956}
          x={715}
          y={138}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER AT THE OVERHEAD ZONE OF VACUUM DEARATOR"
        />
        <Transmitter
          tag="PT-2957"
          value={PT_2957}
          x={1096}
          y={83}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF DEARATED AIR FROM DEARATOR VACUUM PUMPS TO ATMOSPHERE"
        />

        <Transmitter
          tag="FIC-2957"
          value={[FIC_2957]}
          x={512}
          y={650}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED WATER FROM VACUUM DEARATOR TO BOOSTER INJECTION PUMPS"
        />
        <Transmitter
          tag="FIC-2958"
          value={[FIC_2958]}
          x={615}
          y={594}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED WATER FROM VACUUM DEARATOR AND SURGE TANK TO BOOSTER INJECTION PUMPS"
        />
        <Transmitter
          tag="FIC-2959"
          value={[FIC_2959]}
          x={741}
          y={594}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED WATER FROM VACUUM DEARATOR AND SURGE TANK TO BOOSTER INJECTION PUMPS"
        />

        
        <Transmitter
          tag="PT-29511"
          value={PT_29511}
          x={816}
          y={594}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.11}
          LL={0.09}
          c="lime"
          description="PRESSURE OF DE-OXYGENATED WATER FROM VACUUM DEARATOR TO BOOSTER INJECTION PUMPS"
        />

        
        <Transmitter
          tag="FIC-2956"
          value={[FIC_2956]}
          x={1216}
          y={464}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED SEAWATER FROM DISCHARGE OF BOOSTER INJECTION PUMPS"
        />

        
        <Transmitter
          tag="PT-29510"
          value={PT_29510}
          x={936}
          y={476}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF DE-OXYGENATED WATER FROM DISCHARGE OF BOOSTER INJECTION PUMPS"
        />
        
        <Transmitter
          tag="FIC-2955"
          value={[FIC_2955]}
          x={826}
          y={392}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED SEAWATER AT SUCTION OF MAIN WATER INJECTION PUMPS"
        />

        
        <Transmitter
          tag="PT-2958"
          value={PT_2958}
          x={925}
          y={326}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.1}
          LL={0.06}
          c="lime"
          description="PRESSURE OF DE-OXYGENATED SEAWATER AT SUCTION OF MAIN WATER INJECTION PUMPS"
        />

        <Transmitter
          tag="FIC-2954"
          value={[FIC_2954]}
          x={1160}
          y={238}
          unit="LPM"
          max={250}
          HH={240}
          H={220}
          L={50}
          LL={20}
          c="lime"
          description="FLOWRATE OF DE-OXYGENATED SEAWATER AT DISCHARGE OF MAIN WATER INJECTION PUMPS"
        />

        
        <Transmitter
          tag="PT-2959"
          value={PT_2959}
          x={1213}
          y={333}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.1}
          LL={0.04}
          c="lime"
          description="PRESSURE OF DE-OXYGENATED SEAWATER AT DISCHARGE OF MAIN WATER INJECTION PUMPS"
        />

        






        <Transmitter
          tag="DOT-2951"
          value={DOT_2951}
          x={301}
          y={178}
          unit="ppm"
          max={10}
          HH={9}
          H={8.5}
          L={0.2}
          LL={0.05}
          c="lime"
          description="DISSOLVED OXYGEN LEVEL TRANSMITER FOR SEAWATER TO VACUUM DEARATOR FLASH ZONE"
        />

        <Transmitter
          tag="DOT-2952"
          value={DOT_2952}
          x={539}
          y={594}
          unit="ppm"
          max={0.5}
          HH={0.45}
          H={0.25}
          L={0.02}
          LL={0.01}
          c="lime"
          description="DISSOLVED OXYGEN LEVEL TRANSMITER FOR SEAWATER AT DISCHARGE OF VACUUM DEARATOR IN PPM"
        />
        <Transmitter
          tag="DOT-2952a"
          value={DOT_2952a}
          x={539}
          y={603}
          unit="ppb"
          max={40}
          HH={30}
          H={250}
          L={10}
          LL={5}
          c="lime"
          description="DISSOLVED OXYGEN LEVEL TRANSMITER FOR SEAWATER AT DISCHARGE OF VACUUM DEARATOR IN PPB"
        />


        
    <Pump
      tag="P-2951A"
      x={1041}
      y={495}
      rpm={1800}
      bladeCount={pumpData?.["P-2951A"]?.bladeCount || 3}
      size={pumpData?.["P-2951A"]?.size || 38}
      onClick={openPumpPanel}
    />

  
    <Pump
      tag="P-2951B"
      x={1045}
      y={605}
      rpm={1800}
      bladeCount={pumpData?.["P-2951B"]?.bladeCount || 3}
      size={pumpData?.["P-2951B"]?.size || 38}
      onClick={openPumpPanel}
    />

        
    <Pump
      tag="P-2952A"
      x={1045}
      y={264}
      rpm={1800}
      bladeCount={pumpData?.["P-2952A"]?.bladeCount || 3}
      size={pumpData?.["P-2952A"]?.size || 38}
      onClick={openPumpPanel}
    />

  
    <Pump
      tag="P-2952B"
      x={1048}
      y={374}
      rpm={1800}
      bladeCount={pumpData?.["P-2952B"]?.bladeCount || 3}
      size={pumpData?.["P-2952B"]?.size || 38}
      onClick={openPumpPanel}
    />
        
    <Pump
      tag="P-2953A"
      x={842}
      y={105}
      rpm={1800}
      bladeCount={pumpData?.["P-2953A"]?.bladeCount || 3}
      size={pumpData?.["P-2953A"]?.size || 38}
      onClick={openPumpPanel}
    />

  
    <Pump
      tag="P-2953B"
      x={841}
      y={214}
      rpm={1800}
      bladeCount={pumpData?.["P-2953B"]?.bladeCount || 3}
      size={pumpData?.["P-2953B"]?.size || 38}
      onClick={openPumpPanel}
    />


    
     <LevelTransmitterIndicator
      tag="LT_2951"
      totalLevel={150000}
      inflows={[FIC_2951 + FIC_2952]}
      outflows={[FIC_2957]}
      responseFactor={0.05}
      columnX={464}
      columnY={453}
      columnWidth={88}
      columnHeight={60}
      textX={380}
      textY={450}
      showFlow={true}
    />

     <LevelTransmitterIndicator
      tag="LT_2952"
      totalLevel={50000}
      inflows={[FIC_2957a]}
      outflows={[FIC_2957b]}
      responseFactor={0.05}
      columnX={697}
      columnY={418}
      columnWidth={63}
      columnHeight={74}
      textX={775}
      textY={430}
      showFlow={true}
    />




    </div>
  );
}

export default VacuumDearator; 